export default __webpack_public_path__ + "static/media/sign_up_banner.befd07b9.png";